<template>
<div class="container pb-4">

  <div class="row">
    <div class="col-md-8 mx-auto">
    <h5 class="text-center mb-3">Help</h5>
      <div class="card">
    <div class="card-body">

      <div class="row">
      <div class="col">
        
      <div v-if="sent" class="alert alert-success text-center mb-0" role="alert">
      <div>Your message has been sent and you'll get a reply soon</div>
      <div>Please check your email for confirmation</div>
      </div>

<div v-else>

    <textarea class="form-control shadow-none inputbox" rows="10" placeholder="Type message here" v-model="new_message"></textarea>

    <div class="mt-3">
            <button v-if="!sending"
            @click="formSubmit"
              type="button"
              class="btn btn-danger col py-2">Send Message</button> 

              <button v-else type="button" class="btn btn-danger col py-2">
              <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
    </div>

            </div>
            <div>
        </div>
        </div>
      </div>

    </div>
  </div>

    </div>
  </div>
    
</div>
</template> 

<script>
export default {

  data() {
    return {
      new_message: '',
      sending: false,
      sent: false,
    };
  },

  methods: {

    formSubmit() {

      if (this.new_message !='') {

        this.sending = true;

        let existingObj = this;

        axios
          .post("/help/send", {message: this.new_message})
          .then(function (response) {

            existingObj.new_message = '';
            existingObj.sending = false;
            existingObj.sent = true;

          });

      } else {
        this.sweetfire('Please type a message');
      }

    },

    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
    
  }

}
</script>

<style scoped>
textarea.form-control {
  border: 1px solid #dfdfdf !important;
}

</style>